export default {
  how_to_place_order: {
    header: 'How do I place an order?',
    body: 'Simply browse the menu, add items to your cart, and follow the checkout steps. You’ll receive a confirmation once the order is placed.',
  },
  schedule_order: {
    header: 'Can I schedule an order in advance?',
    body: 'Yes! At checkout, choose the “Schedule” option to set a future pickup time that works best for you.',
  },
  customize_order: {
    header: 'Can I customize my order?',
    body: 'Absolutely. Tap on a menu item to see customization options such as toppings, sides, and preferences.',
  },
  track_order: {
    header: 'How do I track my order?',
    body: 'After placing your order, you’ll see real-time updates in the app—from confirmation to preparation and pickup readiness.',
  },
  cancel_or_edit_order: {
    header: 'Can I cancel or edit my order after placing it?',
    body: 'If your order hasn’t started being prepared, you can request changes by calling the restaurant directly through the app.',
  },
  payment_methods: {
    header: 'What payment methods do you accept?',
    body: 'We accept major credit/debit cards, Apple Pay, and Google Pay, depending on your device.',
  },
  no_confirmation: {
    header: 'I didn’t receive a confirmation. What should I do?',
    body: 'Check your email’s spam folder or visit the Orders tab in the app. If you still don’t see it, contact the restaurant directly.',
  },
  pickup_instructions: {
    header: 'Where do I pick up my order?',
    body: 'Pickup instructions are shown on the confirmation screen and in your order summary. Look for signage or ask staff upon arrival.',
  },
  loyalty_points: {
    header: 'Can I earn loyalty points with my orders?',
    body: "Yes, eligible purchases automatically earn points. You can view your balance and rewards in the app's main screen.",
  },
  apply_promo_code: {
    header: 'How do I apply a promo code or discount?',
    body: 'During checkout, you’ll see an option to enter a promo code. Available discounts are also applied automatically if eligible.',
  },
  issue_with_order: {
    header: 'What should I do if there’s an issue with my order?',
    body: 'We’re here to help. Contact the restaurant through the app or email support directly using the Contact Support option.',
  },
  use_loyalty_and_coupon: {
    header: 'Can I use loyalty points and a coupon (like Buy 1 Get 1 Free) on the same order?',
    body: 'No—only one discount or offer can be applied per order. This helps ensure fair use of rewards and promotions. Choose the option that gives you the best value!',
  },
};
